import { render } from "./PlatformLogo.vue?vue&type=template&id=fbc1650e&scoped=true"
const script = {}

import "./PlatformLogo.vue?vue&type=style&index=0&id=fbc1650e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fbc1650e"]])

export default __exports__